export enum DraftJobChangeStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED'
}
